<section class="flex items-center h-full p-16 dark:bg-gray-50 dark:text-gray-800">
	<div class="container flex flex-col items-center justify-center px-5 mx-auto my-8">
		<div class="max-w-md text-center">
			<h2 class="mb-8 font-extrabold text-9xl dark:text-gray-400">
				<span class="sr-only">Error</span>403
			</h2>
			<p class="text-2xl font-semibold md:text-3xl">No cuenta con privilegio de acceder a la web</p>
			<p class="mt-4 mb-8 dark:text-gray-600">Usuario <span class="font-semibold">{{ session.fullName }}</span> con correo electrónico <span class="font-semibold">{{ session.email }}</span>  no cuenta con acceso al sitio.</p>
		</div>
	</div>
</section>
